let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f61vc")).then(() => parcelRequire('cBdWJ'));